import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { AppsService } from '../../../apps.service';
import { App, AppKey, AppModal } from '../../app';

@Component({
    selector: 'rosie-app-calendar-conflict',
    templateUrl: './app-calendar-conflict.component.html',
    styleUrls: ['./app-calendar-conflict.component.scss'],
    standalone: false
})
export class AppCalendarConflictComponent {

    @Input() app: App;
    @Input() conflictingApp: App;

    @Output() continueInstall = new EventEmitter<void>();

    constructor(private apps: AppsService, private modal: NgxSmartModalService) {
    }

    get conflictingAppName(): string {
        return this.conflictingApp?.name || '';
    }

    get newAppName(): string {
        return this.app?.name || '';
    }

    get warningMessage(): string {
        const warning = 'You can only have one Calendar provider installed at a time.';
        const description = `By continuing with the ${this.newAppName} installation, we will disconnect ${this.conflictingAppName} and disable Rosie's ability to directly schedule appointments until you reenable with ${this.newAppName}.`;
        return `<b class="d-block">${warning}</b>${description}`;
    }

    close(): void {
        this.modal.getModal(AppModal.CalendarConflict).close();
    }

    confirm(): void {
        this.continueInstall.emit();
        this.close();
    }

}

